<template>
    <div>
         <div class="destination-area search-form-item" 
            :class="{ 'col-md-4 col-sm-4 col-xs-4': groupDests2.length == 0, 'col-md-3 col-sm-3 col-xs-3': groupDests2.length > 0}" style="">
            <div v-if="groupDests2.length == 0 
                && index < groupCount - 1" 
                    class="destination-area-line"></div>
            <div v-else class="f-dn"></div>
                    
            <div class="destination-area-name search-form-title" :data-country="group" :data-cruise="cruiseType">
                <div class="item-line"></div>
                <span class="search-form-list-item-text" :data-cruise="cruiseType" data-toggle="tooltip" 
                data-placement="right" :data-title="hpDestinationTips">
                    {{group}}
                </span>
            </div>
            <div class="destination-area-list search-form-list">
                <div v-if="groupDests1.length > 1" 
                    class="destination-area-item search-form-list-item search-form-list-item-all"
                    data-cnvalue="全部" data-filtercode="全部" data-key="DestinationCode" 
                    :data-cruise="cruiseType" 
                    @click="onDestinationAllClick(group)"
                    :class="{ active: isSelectedAll(group), disable: isDisableAll(group)}"
                    :data-country="group">
                    <div class="search-form-list-item-nochecked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox.png" />
                    </div>
                    <div class="search-form-list-item-checked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox-selected.png" />
                    </div>
                    <span class="search-form-list-item-text" data-toggle="tooltip" data-placement="right" data-title="@hpDestinationTips">全部目的地</span>
                    <div v-if="isSameCountry" class="flag-content">
                        <img class="flag" :src="groupDests1[0].countryFlag">
                        <span class="flag-text">{{groupDests1[0].countryName}}</span>
                    </div>
                    <div v-else class="f-dn"></div>
                </div>
                <div v-else class="f-dn"></div>

                <div v-for="(groupDest, index) in groupDests1" 
                    :key="index"
                    class="destination-area-item search-form-list-item"
                    :data-cnvalue="groupDest.title" 
                    :data-filtercode="groupDest.filterCode" 
                    data-key="DestinationCode" 
                    :data-cruise="cruiseType"
                    :class="{ active: isSelected(groupDest.filterCode), disable: isDisable(groupDest.filterCode) }"
                    @click="onDestinationClick(groupDest)"
                    :data-country="group">
                    <div class="search-form-list-item-nochecked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox.png" />
                    </div>
                    <div class="search-form-list-item-checked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox-selected.png" />
                    </div>
                    <span class="search-form-list-item-text" data-toggle="tooltip" data-placement="right" data-title="@hpDestinationTips">{{groupDest.title}}</span>
                    <div v-if="!isSameCountry" class="flag-content">
                        <img class="flag" :src="groupDest.countryFlag" />
                        <span class="flag-text">{{groupDest.countryName}}</span>
                    </div>
                    <div v-else class="f-dn"></div>
                </div>

            </div>

        </div>
        <div v-if="groupDests2.length > 0" 
            class="destination-area search-form-item col-md-3 col-sm-3 col-xs-3" style="">
            <div v-if="index < groupCount - 1" class="destination-area-line"></div>
            <div v-else class="f-dn"></div>

            <div class="destination-area-name search-form-title" data-country="@group" :data-cruise="cruiseType">
                <div class="search-form-list-item-nochecked"></div>
                <div class="search-form-list-item-checked"></div>
            </div>
            <div class="destination-area-list search-form-list">
            

                <div v-for="(groupDest, index) in groupDests2" 
                :key="index"
                class="destination-area-item search-form-list-item"
                :data-cnvalue="groupDest.title" 
                :data-filtercode="groupDest.filterCode" 
                data-key="DestinationCode" 
                :data-cruise="cruiseType" 
                :class="{ active: isSelected(groupDest.filterCode), disable: isDisable(groupDest.filterCode)}"
                @click="onDestinationClick(groupDest)"
                :data-country="group">
                    <div class="search-form-list-item-nochecked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox.png" />
                    </div>
                    <div class="search-form-list-item-checked">
                        <img src="https://resource.rcclchina.com.cn/cruiseSearch/search-checkbox-selected.png" />
                    </div>
                    <span class="search-form-list-item-text" data-toggle="tooltip" data-placement="right" data-title="@hpDestinationTips">{{groupDest.title}}</span>
                    <div v-if="!isSameCountry" class="flag-content">
                        <img class="flag" :src="groupDest.countryFlag" />
                        <span class="flag-text">{{groupDest.countryName}}</span>
                    </div>
                    <div v-else class="f-dn"></div>
                </div>

            </div>

        </div>
        <div v-else class="f-dn"></div>
    </div>
</template>

<script>
export default {
    name: 'DestinationList',
    components: {
    
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        subCategory: {
            type: String,
            default: function() {
                return ""
            }
        },
        group: {
            type: String,
            default: function() {
                return ""
            }
        },
        groupDests1: {
            type: Array,
            default: function() {
                return []
            }
        },
        groupDests2: {
            type: Array,
            default: function() {
                return []
            }
        },
        groupDests: {
            type: Array,
            default: function() {
                return []
            }
        },
        destinations: {
            type: Array,
            default: function() {
                return []
            }
        },
        index: {
            type: Number,
            default: function() {
                return 0
            }
        },
        groupCount: {
            type: Number,
            default: function() {
                return 0
            }
        }
    },
    data () {
        return {
            cruiseNotAllowTips: "<div><img src='https://resource.rcclchina.com.cn/partner/search-bar-tips.png' /></div>",
            selectDestinations: [],
            selectAllDestinationGroups: []
        }
    },
    methods: {
        onDestinationClick (destination) {
            let code = destination.filterCode
            if (this.isDisable(code)) {
                return
            }
            let name = destination.title
            let group = destination.cruiseFilterGroupName
            let isExists = this.selectDestinations.some(item=> item.code == code)
            const cruiseType = this.cruiseType
            const data = { 
                cruiseType,
                key: 'destinations',
                values: [{ code, name }]
            }
            if (isExists) {
                this.selectDestinations = this.selectDestinations.filter(item => !(item.code == code))
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)

                if (this.isSelectedAll(group)) {
                    this.selectAllDestinationGroups = this.selectAllDestinationGroups.filter(item=>!(item == group))
                }

            } else {
                this.selectDestinations.push({ code, name, group })
                this.$store.dispatch('SET_CRUISE_FILTERS', data)

                // 全选逻辑
                if (this.checkDestinationAllSelected(group)) {
                    if (!this.isSelectedAll(group)) {
                        this.selectAllDestinationGroups.push(group)
                    }
                }
            }
        },
        onDestinationAllClick (destinationGroup) {
            const cruiseType = this.cruiseType
            // 反选
            if (this.isSelectedAll(destinationGroup)) {
                this.selectAllDestinationGroups = this.selectAllDestinationGroups.filter(item=>!(item == destinationGroup))
                // 删除该group下所有选择
                const needRemoveDests = this.selectDestinations.filter(item => item.group == destinationGroup)
                this.selectDestinations = this.selectDestinations.filter(item => !(item.group == destinationGroup))
                const data = {
                    cruiseType,
                    key: 'destinations',
                    values: needRemoveDests
                }
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            } else {
                if (this.isDisableAll(destinationGroup)) {
                    return
                }
                const destinations = this.destinations.filter(item=>item.cruiseFilterGroupName == destinationGroup)
                let needAddDests = []
                destinations.forEach((destination) => {
                    if (!this.selectDestinations.some(item => item.code == destination.filterCode)) {
                        let code = destination.filterCode
                        if (!this.isDisable(code)) {
                            let name = destination.title
                            let group = destination.cruiseFilterGroupName
                            needAddDests.push({ code, name, group })
                            this.selectDestinations.push({ code, name, group })
                        }
                    }
                })
                this.selectAllDestinationGroups.push(destinationGroup)
                const data = {
                    cruiseType,
                    key: 'destinations',
                    values: needAddDests
                }
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            }
        },
        checkDestinationAllSelected (desitnationGroup) {
            let departures = this.getDestinationByGroup(desitnationGroup)
            let selectedCount = this.selectDestinations.filter(item => item.group == desitnationGroup).length
            return departures.length == selectedCount
        },
        isSelected (code) {
            return this.selectDestinations.some(item=> item.code == code)
        },
        isSelectedAll (desitnationGroup) {
            return this.selectAllDestinationGroups.includes(desitnationGroup)
        },
        getDestinationByGroup (desitnationGroup) {
            return this.destinations.filter(item => item.cruiseFilterGroupName == desitnationGroup)
        },
        isDisable (code) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].destinations
            if (typeof(code) == "string" && code.indexOf(',')>=0) {
                return !availableItems.some(r=> code.indexOf(r) >= 0)
            }
            return !availableItems.includes(code)
        },
        isDisableAll (group) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].destinations
            let destinationCodes = this.getDestinationByGroup(group).map(item=>item.filterCode)
            return !availableItems.some(item=> destinationCodes.includes(item))
        }
    },
    computed: {
        hpDestinationTips () {
            return this.cruiseNotAllowTips + "<div class='tip-text'><span>您目前选择的是海外出发航线目的地，暂无法同时选择中国/日本出发航线目的地哦</span></div>"
        },
        rowDestinationTips () {
            return this.cruiseNotAllowTips + "<div class='tip-text'><span>您目前选择的是中国/日本出发航线目的地，暂无法同时选择海外出发航线目的地哦</span></div>"
        },
        isSameCountry () {
            if (this.groupDests.length < 2) {
                return false
            }
            let countryName = this.groupDests[0].countryName
            let isSameCountry = true
            this.groupDests.forEach((groupDest) => {
                if (countryName != groupDest.countryName) {
                    isSameCountry = false
                }
            })
            return isSameCountry
        },
        storeDesinations () {
            return this.$store.state.cruise.filterRequest[this.cruiseType].destinations
        }
    },
    watch: {
        storeDesinations (newOne) {
            if (newOne.length == 0 && this.selectDestinations.length > 0) {
                this.selectDestinations = []
                this.selectAllDestinationGroups = []
            }
        }
    }
}
</script>
